import { render } from "./UpgradeAlert.vue?vue&type=template&id=e616c048&scoped=true"
import script from "./UpgradeAlert.vue?vue&type=script&lang=js"
export * from "./UpgradeAlert.vue?vue&type=script&lang=js"

import "./UpgradeAlert.vue?vue&type=style&index=0&id=e616c048&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/dayungs_pos_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e616c048"]])

export default __exports__